import { type FC } from 'react';
import { useTranslation } from 'react-i18next';

import {
  type ArenaPackRewardDto,
  type BoxReward,
} from '@/common/types/shop/marketBoxes';
import { type ArenaOfferInfo } from '@/components/OffersMarket/ArenaOffers/config';
import ProfitDropReward from '@/components/OffersMarket/ArenaOffers/ProfitDrop/ProfitDropReward';
import { H1, StringSmall } from '@/components/Typography/Typography';

interface ProductTitleProfitDropProps {
  info: ArenaOfferInfo;
  reward: BoxReward | ArenaPackRewardDto;
  status: 'notClaimed' | 'claiming' | 'claimed';
}

const ProductTitleProfitDrop: FC<ProductTitleProfitDropProps> = ({
  info,
  status,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <div className="text-center">
        <H1 className="mb-[4px]">{t(info.title)}</H1>
        <StringSmall className="!leading-none mt-1 !text-white/60">
          {status === 'notClaimed' && t('Receive one of four awards')}
        </StringSmall>
      </div>
      <ProfitDropReward />
    </>
  );
};

export default ProductTitleProfitDrop;
